import { React, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";

import {
  Badge,
  Collapse,
  IconButton,
  OutlinedInput,
  MenuItem,
  Tooltip,
  FormControl,
  Select,
} from "@mui/material";

import "./AgentStatus.css";
import DialPad from "./DialPad";
import ChatInternal from "./Internal/ChatInternal";
import Notifications from "./Notifications";
import Timer from "../Helper/Timer";
import { setMakeCall } from "../Store/Actions/CallAction";

export default function AgentStatus({
  changeColor,
  changePage,
  handleChange,
  myInfo,
  stateOptions,
  status,
}) {
  const [isChatInternalShown, setIsChatInternalShown] = useState(false);
  const [isDialPadShown, setIsDialPadShown] = useState(false);
  const [isNotificationsShown, setIsNotificationsShown] = useState(false);

  const [isChatInternalBadgeHidden, setIsChatInternalBadgeHidden] =
    useState(true);

  const [isNotificationsBadgeHidden, setIsNotificationsBadgeHidden] =
    useState(true);

  const [phoneNumber, setPhoneNumber] = useState("");
  const dispatch = useDispatch();
  const { isInAutoDial, selectedAgentID } = useSelector((state) => state.agent);
  const { agentPermission, CurrentState } = useSelector((state) => state.auth);
  const wrapperRef = useRef(null);

  // Clear phoneNumber after call
  useEffect(() => {
    if (CurrentState === "READY") {
      setPhoneNumber("");
    }
  }, [CurrentState]);

  // Update badge visibility when chat storage is updated
  useEffect(() => {
    const handler = () => {
      const chatStorage = JSON.parse(sessionStorage.getItem("chatInternal"));

      if (chatStorage) {
        if (chatStorage.some((chat) => chat.isViewed === false)) {
          setIsChatInternalBadgeHidden(false);
        } else {
          setIsChatInternalBadgeHidden(true);
        }
      }
    };

    window.addEventListener("updateChatInternal", handler);

    return () => {
      window.removeEventListener("updateChatInternal", handler);
    };
  }, []);

  // Show/hide chat internal
  useEffect(() => {
    selectedAgentID && setIsChatInternalShown(true);
  }, [selectedAgentID]);

  useOutsideAlerter(wrapperRef);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          handleClick();
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const handleBoxToggle = () => {
    var divId = document.getElementById("divId");
    divId.style.top = "0px";
    divId.style.boxShadow = "0px 4px 22px 0px rgba(0,0,0,0.4)";
    // divId.style.backgroundColor = "white";
  };

  const handleClick = () => {
    const divId = document.getElementById("divId");
    divId.style.top = "-30px";
    divId.style.boxShadow = "0px 2px 18px 1px rgba(0, 0, 0, 0.18)";
  };

  const handleCall = () => {
    if (phoneNumber.length > 0) {
      dispatch(
        setMakeCall({
          phoneNo: phoneNumber.replace(/-/g, ""),
          agentStatus: CurrentState,
        })
      );

      // Reset phone number in app
      if (!matches) {
        setPhoneNumber("");
      }
    }
  };

  const checkAgentStatus = () => {
    let disabled;

    // Disable during autodial for jiva
    // if (isInAutoDial) {
    //   if (status === "NOT BOUND") {
    //     disabled = true;
    //   } else {
    //     disabled = false;
    //   }
    // } else {
    if (status === "BUSY" || status === "NOT BOUND" || status === "ACW") {
      disabled = true;
    } else {
      disabled = false;
    }
    // }

    return disabled;
  };

  const [matches, setMatches] = useState(
    window.matchMedia("(min-width: 1199.98px)").matches
  );

  useEffect(() => {
    window
      .matchMedia("(min-width: 1199.98px)")
      .addEventListener("change", (e) => setMatches(e.matches));
  }, []);

  const renderChatInternalButton = () => {
    const chatPermission = agentPermission.find(
      (permission) => permission.PermissionCode === "Chat"
    );

    if (chatPermission && chatPermission.PermissionAccess === "A") {
      return (
        <Tooltip title="Chat Internal" arrow>
          <IconButton
            size="small"
            onClick={() => {
              // Disable in auto dial
              if (!isInAutoDial) {
                setIsDialPadShown(false);
                setIsNotificationsShown(false);
                setIsChatInternalShown(!isChatInternalShown);
              }
            }}
          >
            {isChatInternalShown ? (
              <Icon icon="ph:x-bold" height="26" />
            ) : (
              <Badge
                color="primary"
                invisible={isChatInternalBadgeHidden}
                variant="dot"
              >
                <Icon
                  icon="ion:chatbox-ellipses-outline"
                  width="26"
                  height="26"
                />
              </Badge>
            )}
          </IconButton>
        </Tooltip>
      );
    } else {
      return null;
    }
  };

  const renderDialpadButton = () => {
    const manualDialPermission = agentPermission.find(
      (permission) => permission.PermissionCode === "Call.ManualDial"
    );

    if (manualDialPermission && manualDialPermission.PermissionAccess === "A") {
      return (
        <Tooltip title="Dialpad" arrow>
          <IconButton
            size="small"
            onClick={() => {
              // Disable in auto dial
              // if (!isInAutoDial) {
                setIsChatInternalShown(false);
                setIsNotificationsShown(false);
                setIsDialPadShown(!isDialPadShown);
              // }
            }}
          >
            {isDialPadShown ? (
              <Icon icon="ph:x-bold" height="26" />
            ) : (
              <Icon icon="material-symbols:dialpad" height="26" />
            )}
          </IconButton>
        </Tooltip>
      );
    } else {
      return null;
    }
  };

  function renderAgentStateColor() {
    switch (status ? status.split(" - ")[0] : "") {
      case "READY":
        return "BGcolor1";

      case "AUX":
        return "BGcolor2";

      case "OFFLINE":
        return "BGcolor3";

      case "BUSY":
        return "BGcolor4";

      case "ACW":
        return "BGcolor5";

      case "NOT BOUND":
        return "BGcolor3";

      default:
        break;
    }
  }

  return (
    <div className="ContainerAgentStatus">
      {matches && (
        <>
          {CurrentState.includes("AUX") && (
            <div className="aux-timer">
              <p>AUX Time - {<Timer />}</p>
            </div>
          )}

          <div className="agent_status">
            <div className="agent_status_controls">
              <div className="Floaters" style={{ display: "none" }}>
                <RemoveRoundedIcon
                  className="FloatersIcon"
                  sx={{ fontSize: "60px" }}
                  stroke={"white"}
                  strokeWidth={0.5}
                />
              </div>

              <div className="Add_notification">
                {renderDialpadButton()}
                {renderChatInternalButton()}

                <Tooltip title="Notification" arrow>
                  <IconButton
                    size="small"
                    className="Add_notification"
                    onClick={() => {
                      // Disable in auto dial
                      if (!isInAutoDial) {
                        setIsDialPadShown(false);
                        setIsChatInternalShown(false);
                        setIsNotificationsShown(!isNotificationsShown);
                        setIsNotificationsBadgeHidden(true);
                      }
                    }}
                  >
                    {isNotificationsShown ? (
                      <Icon icon="ph:x-bold" height="26" />
                    ) : (
                      <Badge
                        color="primary"
                        invisible={isNotificationsBadgeHidden}
                        variant="dot"
                      >
                        <Icon icon="ion:notifications-outline" height="26" />
                      </Badge>
                    )}
                  </IconButton>
                </Tooltip>
              </div>

              <FormControl
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& > fieldset": {
                      border: "none",
                    },
                  },
                }}
                className={`agent_status_color ${renderAgentStateColor()}`}
              >
                <Select
                  value={status}
                  onChange={handleChange}
                  input={
                    <OutlinedInput
                      sx={{ fontSize: "14px", fontWeight: "600" }}
                    />
                  }
                  displayEmpty
                  className="SelectAgentStatus"
                  disabled={checkAgentStatus()}
                >
                  {stateOptions.map((x) => {
                    return (
                      <MenuItem
                        disabled={isInAutoDial && x.ReasonCode === "READY"}
                        sx={{
                          fontSize: "14px",
                          padding: "6px 12px",
                          justifyContent: "center",
                          display: x.isAllow ? "flex" : "none",
                        }}
                        value={x.ReasonCode}
                        key={x.ReasonCode}
                      >
                        {x.Description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <Collapse in={isDialPadShown} unmountOnExit>
              <DialPad
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
                handleCall={handleCall}
              />
            </Collapse>

            <ChatInternal isShown={isChatInternalShown} />

            <Notifications
              isShown={isNotificationsShown}
              setIsNotificationsShown={setIsNotificationsShown}
              changePage={changePage}
              setIsNotificationsBadgeHidden={setIsNotificationsBadgeHidden}
            />
          </div>
        </>
      )}

      {!matches && (
        <div ref={wrapperRef}>
          <div
            className="agent_status2"
            id="divId"
            onMouseEnter={() => handleBoxToggle()}
          >
            <div className="agent_status2_controls">
              <div className="Floaters">
                <RemoveRoundedIcon
                  className={changeColor ? changeColor : "BGcolor3"}
                  sx={{ fontSize: "60px" }}
                  stroke={"white"}
                  strokeWidth={0.5}
                />
              </div>
              <div className="Add_notification">
                <Tooltip title="Notification" arrow>
                  <IconButton className="Add_notification">
                    <NotificationsOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </div>
              {/* <Tooltip title="Notification" arrow>
                <IconButton
                  size="small"
                  className="Add_notification"
                  onClick={() => {
                    // Disable in auto dial
                    if (!isInAutoDial) {
                      setIsDialPadShown(false);
                      setIsChatInternalShown(false);
                      setIsNotificationsShown(!isNotificationsShown);
                      setIsNotificationsBadgeHidden(true);
                    }
                  }}
                >
                  {isNotificationsShown ? (
                    <Icon icon="ph:x-bold" height="26" />
                  ) : (
                    <Badge
                      color="primary"
                      invisible={isNotificationsBadgeHidden}
                      variant="dot"
                    >
                      <Icon icon="ion:notifications-outline" height="26" />
                    </Badge>
                  )}
                </IconButton>
              </Tooltip> */}

              {/* <span className="StatusAgent_Name">{myInfo.user.AgentName}</span> */}
              <FormControl
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& > fieldset": {
                      border: "none",
                    },
                  },
                }}
                className={`agent_status_color ${changeColor}`}
              >
                <Select
                  value={status}
                  onChange={handleChange}
                  input={<OutlinedInput sx={{ fontSize: "14px" }} />}
                  displayEmpty
                  className="SelectAgentStatus"
                  disabled={status === "NOT BOUND"}
                >
                  {stateOptions.map((x) => {
                    return (
                      <MenuItem
                        disabled={isInAutoDial && x.ReasonCode === "READY"}
                        sx={{
                          fontSize: "14px",
                          padding: "6px 12px",
                          justifyContent: "center",
                          display: x.isAllow ? "flex" : "none",
                        }}
                        value={x.ReasonCode}
                        key={x.ReasonCode}
                      >
                        {x.Description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
          </div>
          {/* <Notifications
            isShown={isNotificationsShown}
            setIsNotificationsShown={setIsNotificationsShown}
            changePage={changePage}
            setIsNotificationsBadgeHidden={setIsNotificationsBadgeHidden}
          /> */}
        </div>
      )}
    </div>
  );
}
